import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import {Checkbox, Input, DatePicker, TimePicker} from 'antd'

import {NumberPicker} from 'components/shared'
import ApproveProductChanges from 'components/shared/ApproveProductChanges'

import './index.css'

const TODAY = moment().startOf('day')

class UpsellView extends React.Component {
  state = {
    products: this.props.products,
    preferredDateTime: null,
    messageForCustomerService: '',
  }

  submit = (approval) => {
    const preferredDateTime = this.state.preferredDateTime ? this.state.preferredDateTime.format() : null
    const products = this.state.products.filter(p => p.selected).map(JSON.stringify)

    return this.props.addUpsellOrder(
      products,
      approval,
      preferredDateTime,
      this.state.messageForCustomerService
    )
  }

  selectedProducts = () => {
    return this.state.products.filter(p => p.selected)
  }

  updateProduct = (index, data) => {
    const products = this.state.products.map((product, i) => {
      if (index === i) {
        return {...product, ...data}
      }
      return product
    })

    this.setState({products}, () => {
      this.props.fetchPreviewOrderBill(this.selectedProducts().map(JSON.stringify))
    })
  }

  setPreferredDateTime = (preferredDateTime) => {
    this.setState({preferredDateTime})
  }

  setComment = (event) => {
    this.setState({messageForCustomerService: event.target.value})
  }

  render() {
    const {
      customerSpecificPriceListUrl,
      brokerPhone,
      previewOrderBill = {},
      loading,
      isSubmitting,
    } = this.props
    const {products} = this.state

    const anyProductSelected = this.selectedProducts().length > 0

    return (
      <div className="upsell photo">
        <div className="section products">
          <div className="products-description">
            <span>Huk av for ønsket produkt</span>
            {!!customerSpecificPriceListUrl && (
              <a href={customerSpecificPriceListUrl} target="_blank" rel="noopener noreferrer">Se prisliste</a>
            )}
            {!loading && !customerSpecificPriceListUrl && 'sumIncVat' in previewOrderBill && (
              <span>kr {previewOrderBill.sumIncVat},-</span>
            )}
          </div>

          {products.map((product, i) => (
            <div
              key={i}
              className="product"
            >
              <Checkbox
                checked={product.selected}
                onChange={(e) => this.updateProduct(i, {selected: e.target.checked})}
              >
                {product.name}
              </Checkbox>
              {'quantity' in product && (
                <NumberPicker
                  min={product.minQuantity}
                  value={product.quantity}
                  onChange={(value) => this.updateProduct(i, {quantity: value})}
                />
              )}
            </div>
          ))}
        </div>

        {this.props.enableComments && (
          <div className="section comment">
            <span>Kommentar til bestilling</span>
            <div className="comment-date">
              <DatePicker
                showToday={false}
                allowClear={false}
                format="ll"
                value={this.state.preferredDateTime}
                onChange={(date) => this.setPreferredDateTime(date)}
                disabledDate={(date) => (!date || date < TODAY)}
              />
              <TimePicker
                allowClear={false}
                format="HH:mm"
                minuteStep={15}
                value={this.state.preferredDateTime}
                onChange={(date) => this.setPreferredDateTime(date)}
              />
            </div>
            <Input.TextArea
              type="text"
              placeholder="Melding til kundeservice"
              value={this.state.messageForCustomerService}
              onChange={(comment) => this.setComment(comment)}
            />
          </div>
        )}

        <ApproveProductChanges
          hasChanges={anyProductSelected}
          brokerPhone={brokerPhone}
          onSubmit={this.submit.bind(this)}
          isSubmitting={isSubmitting}
          submitLabel="Send mersalg"
        />
      </div>
    )
  }
}

UpsellView.propTypes = {
  customerSpecificPriceListUrl: PropTypes.string,
  brokerPhone: PropTypes.string,
  enableComments: PropTypes.bool,
  products: PropTypes.array.isRequired,
  previewOrderBill: PropTypes.object,
  fetchPreviewOrderBill: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  addUpsellOrder: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
}

export default UpsellView
